import { buildCrud, api } from './clients';

const EMAIL_TEMPLATES_ENDPOINT = 'email-templates';
const PUBLIC_EMAIL_TEMPLATES_ENDPOINT = 'public-email-templates';

type EmailTemplateId = number;

type EmailTemplateResponse = {
	id: EmailTemplateId;
	title: string;
	design: { body: Object; counters: Object; schemaVersion: number };
};

type UsedInWorkflowResponse = {
	count: number;
	ids: Array<string>;
};

type EmailTemplatePayload = Omit<EmailTemplateResponse, 'id'>;

export const duplicateTemplate = async (id: EmailTemplateId): Promise<EmailTemplateResponse> =>
	await api.post(`${EMAIL_TEMPLATES_ENDPOINT}/${id}/duplicate/`);

export const duplicatePublicEmailTemplate = async (id: EmailTemplateId): Promise<EmailTemplateResponse> =>
	await api.post(`${PUBLIC_EMAIL_TEMPLATES_ENDPOINT}/${id}/duplicate/`);

const templateUsedInWorkflowsCount = async (id: EmailTemplateId): Promise<UsedInWorkflowResponse> =>
	await api.get(`${EMAIL_TEMPLATES_ENDPOINT}/${id}/workflows/`);

export const useEmailTemplatesCrud = () => {
	const {
		list,
		create,
		partialUpdate,
		delete: deleteMethod,
	} = buildCrud<EmailTemplateId, EmailTemplatePayload, EmailTemplateResponse>(api, EMAIL_TEMPLATES_ENDPOINT);
	return { list, partialUpdate, create, deleteMethod, templateUsedInWorkflowsCount };
};

export const usePublicEmailTemplatesCrud = () => {
	const { list } = buildCrud<EmailTemplateId, EmailTemplatePayload, EmailTemplateResponse>(api, PUBLIC_EMAIL_TEMPLATES_ENDPOINT);
	return { list };
};
